var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.673,
    height: 21.704,
    viewBox: "0 0 17.673 21.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M28.181,13.414a4.8,4.8,0,0,0,2.913,4.392,11.877,11.877,0,0,1-1.5,3.087c-.9,1.322-1.844,2.639-3.323,2.667-1.453.027-1.921-.862-3.582-.862s-2.18.834-3.556.889c-1.428.054-2.515-1.43-3.427-2.747-1.864-2.695-3.288-7.615-1.376-10.935a5.313,5.313,0,0,1,4.491-2.72c1.4-.027,2.725.943,3.582.943s2.464-1.166,4.155-1a5.07,5.07,0,0,1,3.97,2.153,4.909,4.909,0,0,0-2.345,4.13M25.45,5.348a4.782,4.782,0,0,0,1.129-3.465,4.865,4.865,0,0,0-3.2,1.645A4.543,4.543,0,0,0,22.23,6.885a4.025,4.025,0,0,0,3.22-1.537",
    transform: "translate(-13.421 -1.883)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e4bf2d320da25336089f5a05ef8d1b0e.svg";
export { ForwardRef as ReactComponent };